import { useEffect, useState } from "react";
import { isNativeApp } from "../lib/native";

export function useNativeTheme() {
  const [nativeTheme, setNativeTheme] = useState(
    window.NATIVE_THEME || "light",
  );

  useEffect(() => {
    if (!isNativeApp()) return;

    window.__onNativeThemeChange = (theme) => {
      setNativeTheme(theme);
    };
    const handler = (e) => {
      const detail = e.detail;
      if (detail?.theme) setNativeTheme(detail.theme);
    };
    window.addEventListener("nativeThemeChange", handler);

    return () => {
      window.removeEventListener("nativeThemeChange", handler);
      delete window.__onNativeThemeChange;
    };
  }, []);

  return nativeTheme;
}
